export class SystemDto {
  readonly initials: string = '';
  readonly firstName: string = 'Systeem';
  readonly lastName: string = '';
}
